import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import { MonthlySalesReportHeader } from "./GridHeaders/MonthlySalesReportHeader";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { raportColumns, raportMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";


export default function MonthlyExpenseReport() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'FinanceStatement/MonthlyExpenseReport', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
            // setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const amount0Total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Vlera0), 0);
    }, [data]);

    const amount8Total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Vlera8), 0);
    }, [data]);

    const amount18Total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Vlera18), 0);
    }, [data]);

    const totalNoVATAmount = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TotalPaTVSH), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        muaji: item.Muaji,
        trs: (item.Transaksione),
        amount0: (item.Vlera0),
        amount8: (item.Vlera8),
        amount18: (item.Vlera18),
        totalamount: (item.TotalPaTVSH),
    }));


    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">

            <TitleElements
                icon={SiHyperledger}
                title="Raporti mujor i shpenzimeve"
            />

            <ElementsParagraph text="Raporti mujor i shpenzimeve është raport sintetik që bën grumbullimin e shpenzimeve në secilin muaj të vitit fiskal." />

            <hr></hr>
            <ExcelFormat
                data={data}
                fileName={`Raporti mujor i shpenzimeve`}
                columns={raportColumns}
                columnMappings={raportMappings}
                buttonText="XLSX"
            />

            <DataGridComponent columns={MonthlySalesReportHeader} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: 1, label: 'Vlera 0%', value: amount0Total },
                    { id: 2, label: 'Vlera 8%', value: amount8Total },
                    { id: 3, label: 'Vlera 18%', value: amount18Total },
                    { id: 3, label: 'Vlera Pa TVSH', value: totalNoVATAmount },
                ]}
            />
        </div>
    )
}